<template>
  <div class="app-contanier">
    <div class="back" @click="back">
      <van-icon name="arrow-left" size="0.5rem" /><span>返回</span>
    </div>
    <div class="content">
      <div class="price-row">
        <span>支付：</span>
        <div class="price"><em>￥</em>{{ totalPrice }}</div>
      </div>
      <div class="isPrint">
        <van-checkbox v-model="isPrint" icon-size="34px" checked-color="#ee0a24">是否打印小票</van-checkbox>
      </div>
      <div class="pop-pos">
        <div class="eg-bg">
          <van-image width="7.38rem" height="7.98rem" fit="contain" :src="require('@/assets/bg03.png')" />
        </div>
      </div>
      <div class="other" @click="onOther">选择其他支付方式</div>
    </div>
    <div class="time">({{ sendmsg }})</div>
    <van-popup v-model="popupShow0" closeable round position="center" :close-on-click-overlay="false">
      <div class="pop">
        <div class="tit">请在下方区域扫描二维码</div>
        <div class="eg-bg">
          <van-image width="7.38rem" height="7.98rem" fit="contain" :src="require('@/assets/bg01.png')" />
          <div class="eg">
            <van-image width="2.8rem" height="2.8rem" fit="contain" :src="require('@/assets/code.png')" />
          </div>
          <div class="line"></div>
        </div>
        <div class="pay-list">
          <div v-for="(item, idx) in payList" :key="idx" class="pay-item" :class="{ disabled: item.disabled }"
            :style="{ 'background-color': item.bg }" @click="onPay(item)">
            <van-image width="0.88rem" height="0.88rem" :src="item.icon" /><span>{{ item.text }}</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getData, jmReadCard } from "@/api/home";
import { Toast } from "vant";
import serialPortCommon from "@/utils/serialPortCommon";
export default {
  data() {
    return {
      totalPrice: 0,
      orderNumber: "",
      carnum: 0,
      payList: [
        // {
        //   icon: require('@/assets/icon-card.png'),
        //   type: 1,
        //   text: "刷饭卡",
        //   bg: '#E4F2FF',
        //   mode: '饭卡',
        //   disabled: false
        // },
        {
          icon: require("@/assets/icon-scan.png"),
          type: 2,
          text: "支付码支付",
          bg: "#FFF1CF",
          mode: "会员码",
          disabled: false,
        },
        {
          icon: require("@/assets/icon-wx.png"),
          type: 3,
          text: "微信支付",
          bg: "#E0FFE0",
          mode: "微信",
          disabled: false,
        },
        {
          icon: require("@/assets/icon-alipay.png"),
          type: 4,
          text: "支付宝支付",
          bg: "#E0EFFF",
          mode: "支付宝",
          disabled: false,
        },
      ],
      isPrint: false,
      sendmsg: 120,
      flag: true,
      timer: null,
      unsubscribe: null,
      cleanupPromise: null,
      popupShow0: false,
      payType: 1,
    };
  },
  created() {
    Object.assign(this, {
      totalPrice: this.$route.params.totalPrice || 0,
      orderNumber: this.$route.params.orderNumber || "",
      carnum: this.$route.params.carnum || 0,
    });
    this.timer = setInterval(() => {
      if (--this.sendmsg <= 0) this.back();
    }, 1000);
    this.initSerial();
    let scan = "";
    this._keyHandler = (e) => {
      if (this.flag && this.payType !== 1 && e.key === "Enter") {
        this.pay(scan, false);
        scan = "";
      } else if (this.flag && this.payType !== 1 && e.key && e.key.length === 1)
        scan += e.key;
    };
    document.addEventListener("keydown", this._keyHandler);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this._keyHandler);
    this.cleanupSerial();
  },
  methods: {
    async initSerial() {
      // The payment-method popup can be opened while face payment is still active.
      // Keep the existing connection/listener instead of creating duplicates.
      if (serialPortCommon.connected) {
        if (!this.unsubscribe) {
          this.unsubscribe = serialPortCommon.addDataListener(this.onPacket);
        }
        return;
      }
      try {
        await serialPortCommon.connect();
        if (!this.unsubscribe) {
          this.unsubscribe = serialPortCommon.addDataListener(this.onPacket);
        }
        await serialPortCommon.sendCommand(this.orderNumber);
      } catch (e) {
        this.unsubscribe = null;
        Toast(e.message);
        console.error(e);
      }
    },
    async onPacket(packet) {
      if (packet.command !== 0x02 || !this.flag) return;

      const resultMessages = {
        0x01: "消费失败",
        0x03: "消费超限",
        0x04: "交易未决，请重新放卡确认交易",
        0x05: "卡已被禁用",
        0x06: "本次消费需要验密",
        0x0a: "卡已损坏",
        0x0e: "卡内余额不足",
        0x69: "消费机不可用",
      };

      if (packet.returnCode !== 0x00) {
        Toast(
          resultMessages[packet.returnCode] ||
            `消费失败，返回码：0x${packet.returnCode
              .toString(16)
              .padStart(2, "0")
              .toUpperCase()}`
        );
        return;
      }

      this.flag = false;
      const receive = serialPortCommon
        .bytesToHex(packet.raw)
        .replace(/\s/g, "");
      try {
        await this.pay(receive);
      } finally {
        this.flag = true;
      }
    },
    async pay(code) {
      if (!code) return;
      this.flag = false;
      try {
        await getData("pay", { payCode: code, orderNumber: this.orderNumber });
        const last = this.orderNumber.slice(
          -Math.floor(this.orderNumber.length / 3)
        );
        this.$router.push({
          name: "success",
          params: {
            totalPrice: this.totalPrice,
            orderNumber: last,
            isPrint: this.isPrint ? "1" : "",
          },
        });
      } catch (e) {
        Toast("支付失败");
        this.flag = true;
      }
    },
    async onOther() {
      this.payType = 2;
      this.popupShow0 = true;
      // Do not disconnect here: the user may scan their face while the popup is
      // open, or immediately after closing it.
      await this.initSerial();
    },
    onPay(item) {
      if (item.disabled) return;
      this.payType = item.type;
      this.popupShow0 = false;
    },
    async cleanupSerial() {
      if (this.cleanupPromise) return this.cleanupPromise;
      this.cleanupPromise = this.doCleanupSerial();
      return this.cleanupPromise;
    },
    async doCleanupSerial() {
      try {
        clearInterval(this.timer);
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
        if (serialPortCommon.connected) {
          try {
            await serialPortCommon.cancelTransaction();
          } catch (e) {}
        }
        await serialPortCommon.disconnect();
      } finally {
        // A completed cleanup must not block a later reconnect attempt.
        this.cleanupPromise = null;
      }
    },
    async back() {
      await this.cleanupSerial();
      if (this.$route.name === "payJM") this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.back {
  margin: 24px 0 14px 24px;
  display: flex;
  align-items: center;
}

.content {
  padding: 20px 10px 15px;
  width: 90%;
  margin: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.price-row {
  text-align: center;
  display: flex;
  justify-content: center;
  font-size: 24px;
}

.price {
  color: #db0b11;
}

.price em {
  font-size: 20px;
  font-style: normal;
}

.isPrint {
  margin: 16px auto;
}

.van-checkbox {
  justify-content: center;
}

.pop-pos {
  text-align: center;
  height: 330px;
  padding-top: 25px;
}

.other {
  text-align: center;
  color: #409eff;
}

.time {
  text-align: center;
  margin-top: 15px;
  font-size: 18px;
}

.pop {
  padding: 25px;
  width: 315px;
  text-align: center;
}

.tit {
  font-size: 18px;
}

.eg-bg {
  position: relative;
}

.eg {
  position: absolute;
  bottom: 0;
  right: 32px;

  animation: shaking 1.25s linear infinite;
  -webkit-animation: shaking 1.25s linear infinite;
}

.line {
  position: absolute;
  width: 111px;
  height: 3px;
  right: 30px;
  bottom: 75px;
  background-color: #ff0000;
}

.pay-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 10px;
}

.pay-item {
  padding: 10px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
}

.pay-item.disabled {
  opacity: 0.6;
}

@keyframes shaking {
  20% {
    bottom: 20px;
  }

  40% {
    bottom: 30px;
  }

  60% {
    bottom: 40px;
  }

  80% {
    bottom: 20px;
  }

  100% {
    bottom: 0;
  }
}
</style>
